import { accordionData } from './accordion';
import { alertTokens } from './alert';
import { avatarTokens } from './avatar';
import { badgeTokens } from './badge';
import { bannersTokens } from './banner';
import { buttonTokens } from './button';
import { chipTokens } from './chip';
import { iconButtonTokens } from './iconButton';
import { inputStepperData } from './inputStepper';
import { menuTokens } from './menu';
import { roundButtonTokens } from './roundButton';
import { popoverTokens } from './popover';
import { presenceIndicatorTokens } from './presenceIndicator';
import { progressIndicatorTokens } from './progressIndicator';
import { switchTokens } from './switch';
import { selectTokens } from './select';
import { snackbarTokens } from './snackbar';
import { textFieldTokens } from './textField';
import { dialogTokens } from './dialog';
import { toolbarData } from './toolbarButton';
import { checkboxTokens } from './checkbox';
import { bottomNavigationTokens } from './bottomNavigation';
import { elevationTokens } from './elevation';
import { tabsTokens } from './tabs';
import { contextualActionTokens } from './contextualAction';
import { thumbnailData } from './thumbnail';
import { codeData } from './code';
import { navigationRailsData } from './navigationRails';
import { radioButtonData } from './radioButton';
import { emptyStateData } from './emptyState';
import { tooltipData } from './tooltip';
import { iconBadgeData } from './iconBadge';
import { linkTokens } from './link';
import { navDrawerData } from './navDrawer';
import { progressStepperData } from './progressStepper';
export * from './typography';
export const chameleonComponents = [
    accordionData,
    alertTokens,
    avatarTokens,
    badgeTokens,
    bannersTokens,
    bottomNavigationTokens,
    buttonTokens,
    checkboxTokens,
    chipTokens,
    codeData,
    contextualActionTokens,
    dialogTokens,
    elevationTokens,
    emptyStateData,
    iconBadgeData,
    iconButtonTokens,
    inputStepperData,
    linkTokens,
    menuTokens,
    navDrawerData,
    navigationRailsData,
    popoverTokens,
    presenceIndicatorTokens,
    progressIndicatorTokens,
    progressStepperData,
    radioButtonData,
    roundButtonTokens,
    selectTokens,
    snackbarTokens,
    switchTokens,
    tabsTokens,
    textFieldTokens,
    thumbnailData,
    toolbarData,
    tooltipData,
];
